export default __webpack_public_path__ + "static/media/870.b5d198d4.png";